import React, { useEffect, useRef, useState } from "react";
import {
  Modal,
  Form,
  Input,
  DatePicker,
  Row,
  Col,
  Select,
  Button,
} from "antd";

import { SpecialitesService } from "../Services/SpecialitesService";
import { ListFournisService } from "../Services/ListFournisService";
import Draggable from "react-draggable";

const { Option } = Select;
const { RangePicker } = DatePicker;

const DraggableModal = ({ children, ...props }) => {
  const [disabled, setDisabled] = useState(true);
  const draggleRef = useRef(null);

  return (
    <Modal
      {...props}
      modalRender={(modal) => (
        <Draggable
          disabled={disabled}
          bounds={draggleRef.current ? draggleRef.current : undefined}
          handle=".ant-modal-title"
        >
          <div ref={draggleRef}>{modal}</div>
        </Draggable>
      )}
      title={
        <div
          className="ant-modal-title"
          style={{ width: '100%', cursor: 'move' }}
          onMouseOver={() => setDisabled(false)}
          onMouseOut={() => setDisabled(true)}
        >
          {props.title}
        </div>
      }
    >
      {children}
    </Modal>
  );
};

const AdvancedSearchReglmt = ({ visible, onClose, onSearch, tableData }) => {
  const [specialitesData, setSpecialitesData] = useState([]);
  const [prescripteursData, setPrescripteursData] = useState([]);
  const [createdByData, setCreatedByData] = useState([]);
  const [processByData, setProcessByData] = useState([]);
  const [isReceived, setIsReceived] = useState(false);
  const [form] = Form.useForm();

  const specialistesService = new SpecialitesService();
  const fournisseurService = new ListFournisService();

  const extractUniqueValues = (data, key) => {
    return [...new Set(data.map((item) => item[key]).filter(Boolean))];
  };

  useEffect(() => {
    if (tableData && tableData.length > 0) {
      setCreatedByData(extractUniqueValues(tableData, "created_by"));
      setProcessByData(extractUniqueValues(tableData, "process_by"));

      // Vérifier si l'état est "R" (Reçue)
      const hasReceivedState = tableData.some((item) => item.etat === "R");
      setIsReceived(hasReceivedState);
    }
  }, [tableData]);

  const handleSearch = () => {
    form
      .validateFields()
      .then((values) => {
        // Vérification si les dates sont déjà des chaînes au format "YYYY-MM-DD"
        const formattedValues = {
          ...values,
          datefact: values.datefact
            ? values.datefact.map((date) => {
                return typeof date === "string" ? date : date.format("YYYY-MM-DD");
              })
            : null,
          daterecep: values.daterecep
            ? values.daterecep.map((date) => {
                return typeof date === "string" ? date : date.format("YYYY-MM-DD");
              })
            : null,
        };
        onSearch(formattedValues); // Passer les valeurs formatées à onSearch
        onClose(); // Fermer la modal
      })
      .catch((info) => {
        console.log("Validation Failed:", info);
      });
  };
  
  const fetchSpecialite = async () => {
    try {
      const specialites = await specialistesService.getAllSpecialites();
      setSpecialitesData(specialites);
    } catch (error) {
      console.error("Erreur lors de la récupération des spécialités :", error);
    }
  };

  const handleFournisPrescChange = async (value) => {
    try {
      const allFournisseurs = await fournisseurService.getAllListFournis();
      const prescripteurs = allFournisseurs.filter(
        (fournisseur) => fournisseur.intitule === value
      );
      setPrescripteursData(prescripteurs);
    } catch (error) {
      console.error("Erreur lors de la récupération des prescripteurs :", error);
    }
  };

  useEffect(() => {
    fetchSpecialite();
  }, []);

  useEffect(() => {
    if (!visible) {
      form.resetFields();
      setPrescripteursData([]);
    }
  }, [visible, form]);

  const handleCancel = () => {
    form.resetFields(); // Réinitialiser seulement les champs du formulaire
  };

 
  return (
    <DraggableModal
      title="Recherche Avancée"
      open={visible}
      onCancel={onClose}
      onOk={handleSearch}
      width={800}
      maskClosable={false}
      footer={[
        <Button key="reset" onClick={handleCancel}>
          Réinitialiser
        </Button>,
        <Button key="search" type="primary" onClick={handleSearch}>
          Rechercher
        </Button>,
      ]}
    >
      <Form form={form} layout="vertical">
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item name="intitule" label="Spécialités">
              <Select
                showSearch
                placeholder="--Sélectionner--"
                style={{ width: "100%" }}
                onChange={handleFournisPrescChange}
              >
                {specialitesData.map((specialite) => (
                  <Option key={specialite.intitule} value={specialite.intitule}>
                    {`${specialite.codespe} - ${specialite.intitule}`}
                  </Option>
                ))}
              </Select>
            </Form.Item>
            <Form.Item label="N° Facture" name="numenreg">
              <Input />
            </Form.Item>
            
          
            {/* Plage de dates pour la date de réception */}
            <Form.Item label="Date Réception (De Date à Date)" name="daterecep">
              <RangePicker style={{ width: "100%" }} format="DD/MM/YYYY" />
            </Form.Item>
            <Form.Item label="Saisie par" name="created_by">
            <Select placeholder="--Sélectionner--" style={{ width: "100%" }}>
                {createdByData.map((user) => (
                  <Option key={user} value={user}>
                    {user}
                  </Option>
                ))}
              </Select>
            </Form.Item>

          </Col>
          <Col span={12}>
            <Form.Item name="raisoc" label="Fournisseur">
              <Select
                placeholder="--Sélectionner--"
                style={{ width: "100%" }}
                showSearch
              >
                {prescripteursData.map((prescripteur) => (
                  <Option key={prescripteur.raisoc} value={prescripteur.raisoc}>
                    {prescripteur.raisoc}
                  </Option>
                ))}
              </Select>
            </Form.Item>
            <Form.Item label="N° Fournisseur" name="numfourn">
              <Input />
            </Form.Item>
          
            {/* Plage de dates pour la date de facture */}
            <Form.Item label="Date Facture (De Date à Date)" name="datefact">
              <RangePicker style={{ width: "100%" }} format="DD/MM/YYYY" />
            </Form.Item>
            {!isReceived && (
              <Form.Item label="Traitée par" name="process_by">
                <Select placeholder="--Sélectionner--" style={{ width: "100%" }}>
                  {processByData.map((user) => (
                    <Option key={user} value={user}>
                      {user}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            )}
          </Col>
        </Row>
      </Form>
    </DraggableModal>
  );
};

export default AdvancedSearchReglmt;
